import {RestApiService} from '../../../rest-api.service';
import {Observable} from 'rxjs';
import {BaseCollectionModel, BaseRestEndpoint, SearchModel} from '@yasc/yasc-material-components';
import {ApiV0Fibu} from '../api.v0.fibu';
import {
    BookingCsvImportReq,
    BookingImportTemplateRes,
    BookingReq,
    BookingRes,
    BookJournalReq,
    FibuOcrFileReq,
    FibuOcrFileRes
} from '../../../../contracts/v0/fibu/booking.contract';
import {FibuExportReq, FibuExportStatsRes} from '../../../../contracts/v0/fibu/export.contracts';
import {FibuBookingType} from '../../../../enums/fibu.enums';

export class ApiV0FibuBooking extends BaseRestEndpoint<BookingRes, BookingReq> {

    constructor(v0: ApiV0Fibu, private restApi: RestApiService) {
        super(`${v0.segment}/booking`, restApi, BookingRes)
    }

    bookJournal(ids: number[]): Observable<void> {
        let dto = new BookJournalReq(ids);
        return this.rest.post<BookJournalReq, void>(
            `${this.segment}/book/Journal`,
            BookingRes,
            dto
        )
    }

    bookBatch(ids: number[]): Observable<void> {
        let dto = new BookJournalReq(ids);
        return this.rest.post<BookJournalReq, void>(
            `${this.segment}/book/batch`,
            BookingRes,
            dto
        )
    }

    private _getBookings(type: FibuBookingType, searchModel?: SearchModel) {
        let qp = {
            "bookingYear": this.restApi.v0.fibu.bookingYear(),
            "bookingMonth": this.restApi.v0.fibu.bookingMonth(),
            "type": type
        }
        return this.rest.post<SearchModel, BaseCollectionModel<BookingRes>>(
            `${this.segment}/search`,
            BookingRes,
            searchModel,
            qp
        )
    }

    getBatchBookings(searchModel?: SearchModel): Observable<BaseCollectionModel<BookingRes>> {
        return this._getBookings(FibuBookingType.BatchBooking, searchModel);
    }

    getJournal(searchModel?: SearchModel): Observable<BaseCollectionModel<BookingRes>> {
        return this._getBookings(FibuBookingType.Journal, searchModel);
    }

    getRecurring(searchModel?: SearchModel): Observable<BaseCollectionModel<BookingRes>> {
        return this._getBookings(FibuBookingType.Recurring, searchModel);
    }

    importCsvData(data: BookingCsvImportReq): Observable<BaseCollectionModel<BookingRes>> {
        return this.rest.post<BookingCsvImportReq, BaseCollectionModel<BookingRes>>(
            `${this.segment}/import/csv`,
            BookingRes,
            data
        )
    }

    importFromPdfs(fileIds: string[]): Observable<BaseCollectionModel<FibuOcrFileRes>> {
        const fileReq = new FibuOcrFileReq(fileIds);

        return this.rest.post<FibuOcrFileReq, BaseCollectionModel<FibuOcrFileRes>>(
            `${this.segment}/import/ocrFiles`,
            FibuOcrFileRes,
            fileReq
        )
    }

    listImportTemplates() {
        return this.rest.get<BaseCollectionModel<BookingImportTemplateRes>>(
            `${this.segment}/import/templates`,
            BookingImportTemplateRes,
        )
    }

    createImportTemplate(templateReq: BookingImportTemplateRes) {
        return this.rest.post<BookingImportTemplateRes, BookingImportTemplateRes>(
            `${this.segment}/import/templates`,
            BookingImportTemplateRes,
            templateReq
        )
    }


    exportAndDownload(model: FibuExportReq, statsOnly: boolean = false) {
        model.statsOnly = statsOnly;
        let qp = {
            "format": model.format,
            "from": model.from.toISOString(),
            "until": model.until.toISOString(),
            "statsOnly": model.statsOnly
        }

        return this.restApi.v0.file.downloadFile(
            `${this.segment}/export`,
            qp
        )
    }

    exportShowStats(model: FibuExportReq, statsOnly: boolean = false) {
        model.statsOnly = statsOnly;

        let qp = {
            "format": model.format,
            "from": model.from.toISOString(),
            "until": model.until.toISOString(),
            "statsOnly": model.statsOnly
        }

        return this.rest.get<FibuExportStatsRes>(
            `${this.segment}/export`,
            FibuExportStatsRes,
            qp
        )
    }
}
